import { render, staticRenderFns } from "./Designated.vue?vue&type=template&id=168c8ddc"
import script from "./Designated.vue?vue&type=script&lang=js"
export * from "./Designated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports